import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-be flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Approved hours by worker")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Download report ")
const _hoisted_7 = {
  key: 1,
  id: "chart"
}
const _hoisted_8 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-light me-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadReport && _ctx.handleDownloadReport(...args)))
          }, [
            (_ctx.isLoadingReport)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : _createCommentVNode("", true),
            _hoisted_6
          ])
        ])
      ])
    ]),
    (_openBlock(), _createElementBlock("div", {
      class: "card-body",
      key: _ctx.key
    }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (!_ctx.isEmpty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_apexchart, {
                type: "pie",
                height: "400",
                options: _ctx.chart.options,
                series: _ctx.chart.options.series
              }, null, 8, ["options", "series"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_el_empty, { description: "No data for the selected filters" })
            ]))
    ]))
  ]))
}